module.exports = __webpack_public_path__ + "static/media/SourceHanSerifCN-Light.e8aba11f.svg";